import React from 'react';
import { LargeGrayButton, GrayButton, SmallGrayButton } from './style';
import { IButton } from './type';

function CoreGrayButton({
	size = 'default',
	_width,
	style_type = 'filled',
	color_type = 'default',
	text,
	_margin,
	_disabled = false,
	_onClick,
	_ref,
	is_loading,
}: IButton) {
	if (size === 'large')
		return (
			<LargeGrayButton
				style_type={style_type}
				_width={_width}
				margin={_margin}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _onClick === undefined) return;
					_onClick(e);
				}}
				ref={_ref}
				is_loading={is_loading}
			>
				<span>{text}</span>
			</LargeGrayButton>
		);

	if (size === 'small')
		return (
			<SmallGrayButton
				style_type={style_type}
				_width={_width}
				margin={_margin}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _onClick === undefined) return;
					_onClick(e);
				}}
				ref={_ref}
				is_loading={is_loading}
			>
				<span>{text}</span>
			</SmallGrayButton>
		);

	return (
		<GrayButton
			style_type={style_type}
			_width={_width}
			margin={_margin}
			disabled={_disabled}
			color_type={color_type}
			onClick={(e) => {
				if (is_loading || _onClick === undefined) return;
				_onClick(e);
			}}
			ref={_ref}
			is_loading={is_loading}
		>
			<span>{text}</span>
		</GrayButton>
	);
}

export default CoreGrayButton;

// props
// - size: large, default, small
// - style_type: filled, tonal, outlined, text (피그마 참고)
// - text: button 텍스트
